var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.15 8.94265C29.7236 8.94265 30.9993 7.61235 30.9993 5.97133C30.9993 4.33031 29.7236 3 28.15 3C26.5764 3 25.3008 4.33031 25.3008 5.97133C25.3008 7.61235 26.5764 8.94265 28.15 8.94265Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48267 15.3088C10.3813 15.3088 11.1099 14.5491 11.1099 13.6119C11.1099 12.6747 10.3813 11.915 9.48267 11.915C8.58399 11.915 7.85547 12.6747 7.85547 13.6119C7.85547 14.5491 8.58399 15.3088 9.48267 15.3088Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0061 15.3088C17.9048 15.3088 18.6333 14.5491 18.6333 13.6119C18.6333 12.6747 17.9048 11.915 17.0061 11.915C16.1074 11.915 15.3789 12.6747 15.3789 13.6119C15.3789 14.5491 16.1074 15.3088 17.0061 15.3088Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2288 15.3088C25.1274 15.3088 25.856 14.5491 25.856 13.6119C25.856 12.6747 25.1274 11.915 24.2288 11.915C23.3301 11.915 22.6016 12.6747 22.6016 13.6119C22.6016 14.5491 23.3301 15.3088 24.2288 15.3088Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2311 4.41494H7.52764C5.62815 4.41494 4 6.25433 4 8.5182V19.1301C4 20.9695 5.08543 22.5259 6.57789 23.0918C6.98492 23.2333 6.84925 23.6578 6.84925 24.0823C6.84925 25.2142 6.84925 26.3462 6.84925 27.3366C6.84925 29.0345 9.56281 27.3366 10.2412 23.7993C10.3769 23.3748 10.7839 23.2333 11.0553 23.2333H26.5226C28.4221 23.2333 30.0502 21.3939 30.0502 19.1301V12.9044",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabChat);
export default __webpack_public_path__ + "static/media/tab_chat.550066a0ccb671d80a384ec7f4317d9c.svg";
export { ForwardRef as ReactComponent };